import React, {Component} from "react";
import {introAssetConfig} from "../../../data/intro"
import {configGame} from "../../../data/config";
import {autoplayAssetConfig} from "../../../../data/autoplay/autoplayconfig";
import {objectTypes} from "../../buttonpanel/interface/Ibuttons";


interface IframeworkMenu {


}

export const frameworkMenu: IframeworkMenu = {
    data: {
        "MENU_CONTAINER_X": 0,
        "MENU_CONTAINER_Y": 0,
        "COMPONENTS": [
            // {
            //     "name": "backgroundImageOfMenu",
            //     "image": autoplayAssetConfig["autoplayBG"],
            //     "type": "Image",
            //     "class": "",
            //     "parentLayer": "specialAnimationLayer",
            //     "visible": true,
            //     "width": 524,
            //     "height": 579,
            //     "x": 380,
            //     "y": 50,
            // },
            //
            // {
            //     "id": "textMenu1",
            //     "name": "text_totalBet",
            //     "type": "Text",
            //     "x":570,
            //     "y": 90,
            //     "height": 100,
            //     "width": 500,
            //     "text": "menuText_1",
            //     "scaleToFit": true,
            //     //"anchor": [0.5, 0.5],
            //     "textStyle": {
            //         fontFamily: 'Arial',
            //         fontSize: 23,
            //         fontStyle: 'normal',
            //         fontWeight: 'bold',
            //         fill: ['#FFFFFF'], // gradient
            //         // stroke: '#4a1850',
            //         // strokeThickness: 0,
            //         dropShadow: true,
            //         dropShadowColor: '#000000',
            //         dropShadowBlur: 4,
            //         dropShadowAngle: Math.PI / 6,
            //         dropShadowDistance: 0,
            //         wordWrap: true,
            //         wordWrapWidth: 800
            //     }
            // },
            //
            // {
            //     "id": "textMenu2",
            //     "name": "text_quickSpin",
            //     "type": "Text",
            //     "x": 530,
            //     "y": 250,
            //     "height": 100,
            //     "width": 200,
            //     "text": "menuText_2",
            //     "scaleToFit": true,
            //     //"anchor": [0.5, 0.5],
            //     "textStyle": {
            //         fontFamily: 'Arial',
            //         fontSize: 17,
            //         fontStyle: 'normal',
            //         fontWeight: 'bold',
            //         fill: ['#ffffff'], // gradient
            //         // stroke: '#4a1850',
            //         // strokeThickness: 0,
            //         dropShadow: true,
            //         dropShadowColor: '#000000',
            //         dropShadowBlur: 4,
            //         dropShadowAngle: Math.PI / 6,
            //         dropShadowDistance: 0,
            //         wordWrap: true,
            //         wordWrapWidth: 800
            //     }
            // },
            // {
            //     "id": "textMenu3",
            //     "name": "ambientMusicText",
            //     "type": "Text",
            //     "x": 530,
            //     "y": 350,
            //     "height": 100,
            //     "width": 220,
            //     "text": "menuText_3",
            //     "scaleToFit": true,
            //     //"anchor": [0.5, 0.5],
            //     "textStyle": {
            //         fontFamily: 'Arial',
            //         fontSize: 17,
            //         fontStyle: 'normal',
            //         fontWeight: 'bold',
            //         fill: ['#ffffff'], // gradient
            //         stroke: '#4a1850',
            //         strokeThickness: 0,
            //         dropShadow: true,
            //         dropShadowColor: '#000000',
            //         dropShadowBlur: 4,
            //         dropShadowAngle: Math.PI / 6,
            //         dropShadowDistance: 0,
            //         wordWrap: true,
            //         wordWrapWidth: 800
            //     }
            // },
            // {
            //     "id": "textMenu4",
            //     "name": "text_soundFX",
            //     "type": "Text",
            //     "x": 530,
            //     "y": 450,
            //     "height": 100,
            //     "width": 220,
            //     "text": "menuText_4",
            //     "scaleToFit": true,
            //     //"anchor": [0.5, 0.5],
            //     "textStyle": {
            //         fontFamily: 'Arial',
            //         fontSize: 17,
            //         fontStyle: 'normal',
            //         fontWeight: 'bold',
            //         fill: ['#ffffff'], // gradient
            //         stroke: '#4a1850',
            //         strokeThickness: 0,
            //         dropShadow: true,
            //         dropShadowColor: '#000000',
            //         dropShadowBlur: 4,
            //         dropShadowAngle: Math.PI / 6,
            //         dropShadowDistance: 0,
            //         wordWrap: true,
            //         wordWrapWidth: 800
            //     }
            // },

        ],
        "ButtonsInCanvas": []
    }


};

export const MenuConfigurationContext = React.createContext(
    {}
);